module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<dl class=\'stepped zero\'>\n    <dt>ID</dt>\n    <dd>' +
((__t = ( id )) == null ? '' : __t) +
'</dd>\n    <dt>' +
((__t = ( i18next.t('common.name') )) == null ? '' : __t) +
'</dt>\n    <dd>' +
((__t = ( name )) == null ? '' : __t) +
'</dd>\n    <dt>' +
((__t = ( i18next.t('glossary.base_url') )) == null ? '' : __t) +
'</dt>\n    <dd>' +
((__t = ( url )) == null ? '' : __t) +
'</dd>\n    <dt>data_points_key</dt>\n    <dd>' +
((__t = ( data_points_key )) == null ? '' : __t) +
'</dd>\n    <dt>endpoint</dt>\n    <dd>' +
((__t = ( endpoint )) == null ? '' : __t) +
'</dd>\n    <dt>param_key</dt>\n    <dd>' +
((__t = ( param_key )) == null ? '' : __t) +
'</dd>\n    <dt>timestamp_key</dt>\n    <dd>' +
((__t = ( timestamp_key )) == null ? '' : __t) +
'</dd>\n    <dt>' +
((__t = ( i18next.t('common.creation') )) == null ? '' : __t) +
'</dt>\n    <dd>' +
((__t = ( WiseMetering.utils.formatDate(created_at) )) == null ? '' : __t) +
' - ' +
((__t = ( creator_name )) == null ? '' : __t) +
'</dd>\n    <dt>' +
((__t = ( i18next.t('glossary.last_change') )) == null ? '' : __t) +
'</dt>\n    <dd>' +
((__t = ( WiseMetering.utils.formatDate(updated_at) )) == null ? '' : __t) +
' - ' +
((__t = ( updater_name )) == null ? '' : __t) +
'</dd>\n</dl>\n\n';

}
return __p
}